// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.1.0';
export const APP_NAME = 'markwins';
export const FILE_HASH = '1768920567816';
export const BUILD_DATE = '2026-01-20T14:49:27.816Z';
/* tslint:enable */
